function formatMoney(amount) {
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
  }).format(amount / 100);
}

function debounce(func, wait) {
  let timeout;
  return function executedFunction(...args) {
    const later = () => {
      clearTimeout(timeout);
      func(...args);
    };
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  };
}

class CartDrawer extends HTMLElement {
  constructor() {
    super();
    this.isCartUpdating = false;

    this.addEventListener(
      "keyup",
      (evt) => evt.code === "Escape" && this.close()
    );
    this.querySelector("#CartDrawer-Overlay").addEventListener(
      "click",
      this.close.bind(this)
    );
    this.setHeaderCartIconAccessibility();
    this.cartDrawer = this.querySelector(".drawer__inner");
    this.cartDrawer.addEventListener(
      "click",
      this.handleCartDrawerClick.bind(this)
    );
    this.updateCartDebounced = debounce(this.updateCart.bind(this), 500);
    this.initializeUpsellButtons();
    this.initializeVariantSelectors();
    // Abrir drawer al añadir producto
    var self = this;
    function tryAttachYz() {
      var btn = document.getElementById('yz-btn');
      if (btn && !btn.dataset.drawerAttached) {
        btn.dataset.drawerAttached = 'true';
        btn.addEventListener('click', function() {
          setTimeout(function() {
            fetch('/?section_id=cart-drawer')
              .then(function(r){return r.text();})
              .then(function(html){
                var p=new DOMParser().parseFromString(html,'text/html');
                var inner=self.querySelector('.drawer__inner');
                var newInner=p.querySelector('.drawer__inner');
                if(inner&&newInner)inner.innerHTML=newInner.innerHTML;
                var footer=document.querySelector('.cart-drawer__footer');
                var newFooter=p.querySelector('.cart-drawer__footer');
                if(footer&&newFooter)footer.innerHTML=newFooter.innerHTML;
                self.classList.remove('is-empty');
                self.open();
              });
          }, 900);
        });
      }
    }
    setTimeout(tryAttachYz, 500);
    setTimeout(tryAttachYz, 1500);
    setTimeout(tryAttachYz, 3000);
  }

  initializeUpsellButtons() {
    var upsellAddButtons = this.querySelectorAll(".upsell-add-button");
    upsellAddButtons.forEach((button) => {
      button.removeEventListener("click", this.handleUpsellButtonClick);
      button.addEventListener("click", this.handleUpsellButtonClick.bind(this));
    });
  }

  initializeVariantSelectors() {
    const variantSelectors = this.querySelectorAll('.upsell-product__variant-selector');
    variantSelectors.forEach(selector => {
      selector.removeEventListener('change', this.handleVariantChange);
      selector.addEventListener('change', this.handleVariantChange.bind(this));
    });
  }

  handleVariantChange(event) {
    const selector = event.target;
    const selectedOption = selector.options[selector.selectedIndex];
    const productContainer = selector.closest('.upsell-product');
    const productImage = productContainer.querySelector('.upsell-product-image');
    const imageUrl = selectedOption.getAttribute('data-image-url');
    const defaultImage = productImage.getAttribute('data-default-image');
    if (imageUrl && !imageUrl.includes('no-image')) {
      productImage.src = imageUrl;
    } else {
      productImage.src = defaultImage;
    }
    const addButton = productContainer.querySelector('.upsell-add-button');
    const checkbox = productContainer.querySelector('.upsell-checkbox');
    if (addButton) {
      addButton.setAttribute('data-product-id', selector.value);
    }
    if (checkbox) {
      checkbox.setAttribute('data-product-id', selector.value);
      checkbox.id = `upsell-product-${selector.value}`;
    }
  }

  handleUpsellButtonClick(event) {
    event.stopPropagation();
    var button = event.target;
    var productId = button.getAttribute("data-product-id");
    var variantSelector = button
      .closest(".upsell-product")
      .querySelector(".upsell-product__variant-selector");
    var variantId = variantSelector ? variantSelector.value : null;
    if (!productId) {
      console.error("Product ID is undefined");
      return;
    }
    this.addProductToCart(productId, variantId, true);
  }

  handleCartDrawerClick(event) {
    const quantityButton = event.target.closest(".quantity__button");
    const removeButton = event.target.closest(".cart-remove-button");
    if (quantityButton || removeButton) {
      setTimeout(() => {
        this.initializeUpsellButtons();
        this.initializeVariantSelectors();
      }, 1000);
    }
  }

  handleUpsellChange(event) {
    var checkbox = event.target;
    var productId = checkbox.getAttribute("data-product-id");
    var variantSelector = checkbox
      .closest(".upsell-product")
      .querySelector(".upsell-product__variant-selector");
    var variantId = variantSelector ? variantSelector.value : null;
    if (!productId) {
      console.error("Product ID is undefined");
      return;
    }
    if (checkbox.checked) {
      this.addProductToCart(productId, variantId);
    } else {
      this.removeProductFromCart(productId);
    }
  }

  updateCart() {
    this.isCartUpdating = true;
    fetch(`${routes.cart_url}?section_id=cart-drawer`)
      .then((response) => {
        if (!response.ok) throw new Error("Network response was not ok");
        return response.text();
      })
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const drawerInner = document.querySelector(".drawer__inner");
        const newDrawerInner = html.querySelector(".drawer__inner");
        if (drawerInner && newDrawerInner) {
          drawerInner.innerHTML = newDrawerInner.innerHTML;
        }
        const cartFooter = document.querySelector(".cart-drawer__footer");
        const newCartFooter = html.querySelector(".cart-drawer__footer");
        if (cartFooter && newCartFooter) {
          cartFooter.innerHTML = newCartFooter.innerHTML;
        }
        this.initializeUpsellButtons();
        this.initializeVariantSelectors();
      })
      .catch((error) => {
        console.error("Error updating cart:", error);
      })
      .finally(() => {
        this.isCartUpdating = false;
      });
  }

  addProductToCart(productId, variantId, isUpsell = false) {
    if (!productId) {
      console.error("Product ID is undefined");
      return;
    }
    if (this.isCartUpdating) {
      console.warn("Cart is currently being updated. Please try again later.");
      return;
    }
    const itemData = {
      items: [{ id: variantId ? variantId : productId, quantity: 1 }]
    };
    fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(itemData),
    })
      .then((response) => {
        if (!response.ok) throw new Error("Failed to add product to cart: " + response.statusText);
        return response.json();
      })
      .then((data) => {
        this.dispatchEvent(new CustomEvent("cartUpdated", { bubbles: true }));
        if (isUpsell) {
          this.updateCart();
        }
      })
      .catch((error) => {
        console.error("Error adding product to cart:", error);
      });
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector("#cart-icon-bubble");
    cartLink.setAttribute("role", "button");
    cartLink.setAttribute("aria-haspopup", "dialog");
    cartLink.addEventListener("click", (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener("keydown", (event) => {
      if (event.code.toUpperCase() === "SPACE") {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute("role"))
      this.setSummaryAccessibility(cartDrawerNote);
    setTimeout(() => {
      this.classList.add("animate", "active");
    });
    this.addEventListener(
      "transitionend",
      () => {
        const containerToTrapFocusOn = this.classList.contains("is-empty")
          ? this.querySelector(".drawer__inner-empty")
          : document.querySelector("#CartDrawer");
        const focusElement =
          this.querySelector(".drawer__inner") ||
          this.querySelector(".drawer__close");
        trapFocus(containerToTrapFocusOn, focusElement);
        this.initializeUpsellButtons();
        this.initializeVariantSelectors();
      },
      { once: true }
    );
    document.body.classList.add("overflow-hidden");
  }

  close() {
    this.classList.remove("active");
    removeTrapFocus(this.activeElement);
    document.body.classList.remove("overflow-hidden");
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute("role", "button");
    cartDrawerNote.setAttribute("aria-expanded", "false");
    if (cartDrawerNote.nextElementSibling.getAttribute("id")) {
      cartDrawerNote.setAttribute("aria-controls", cartDrawerNote.nextElementSibling.id);
    }
    cartDrawerNote.addEventListener("click", (event) => {
      event.currentTarget.setAttribute(
        "aria-expanded",
        !event.currentTarget.closest("details").hasAttribute("open")
      );
    });
    cartDrawerNote.parentElement.addEventListener("keyup", onKeyUpEscape);
  }

  renderContents(parsedState) {
    // Remove is-empty state
    const drawerInner = this.querySelector(".drawer__inner");
    if (drawerInner) drawerInner.classList.remove("is-empty");
    this.classList.remove("is-empty");

    this.productId = parsedState.id;

    // Update drawer inner content
    const cartDrawerSection = parsedState.sections['cart-drawer'];
    if (cartDrawerSection) {
      const parsed = new DOMParser().parseFromString(cartDrawerSection, 'text/html');

      const newCartItems = parsed.querySelector('.drawer__inner');
      if (drawerInner && newCartItems) {
        drawerInner.innerHTML = newCartItems.innerHTML;
      }

      // Update footer (outside .drawer__inner in the DOM)
      const cartFooter = document.querySelector(".cart-drawer__footer");
      const newCartFooter = parsed.querySelector(".cart-drawer__footer");
      if (cartFooter && newCartFooter) {
        cartFooter.innerHTML = newCartFooter.innerHTML;
      }
    }

    // Update cart icon bubble counter
    const cartIconBubbleSection = parsedState.sections['cart-icon-bubble'];
    if (cartIconBubbleSection) {
      const cartIconBubble = document.querySelector("#cart-icon-bubble");
      if (cartIconBubble) {
        const parsed = new DOMParser().parseFromString(cartIconBubbleSection, 'text/html');
        const newIcon = parsed.querySelector('.shopify-section');
        if (newIcon) cartIconBubble.innerHTML = newIcon.innerHTML;
      }
    }

    // Open the drawer
    setTimeout(() => {
      this.open();
      this.initializeUpsellButtons();
      this.initializeVariantSelectors();
    });

    this.dispatchEvent(new CustomEvent("cartUpdated", { bubbles: true }));
  }

  getSectionInnerHTML(html, selector = ".shopify-section") {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      { id: "cart-drawer" },
      { id: "cart-icon-bubble" },
    ];
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define("cart-drawer", CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: "CartDrawer",
        section: "cart-drawer",
        selector: ".drawer__inner",
      },
      {
        id: "cart-icon-bubble",
        section: "cart-icon-bubble",
        selector: ".shopify-section",
      },
    ];
  }
}

customElements.define("cart-drawer-items", CartDrawerItems);